











































import { Component, Vue } from 'vue-property-decorator'
import ActionsBlock from '@/views/Dashboard/ActionsBlock.vue'
import ConversionBlock from '@/views/Dashboard/ConversionBlock.vue'
import LeaderboardBlock from '@/views/Dashboard/LeaderboardBlock.vue'
import RecentReferralsBlock from '@/views/Dashboard/RecentReferralsBlock.vue'
import ReferralsBlock from '@/views/Dashboard/ReferralsBlock.vue'
import LegacyReferralsBlock from '@/views/Dashboard/LegacyReferralsBlock.vue'
import TargetsBlock from '@/views/Dashboard/TargetsBlock.vue'
import WelcomeBlock from '@/views/Dashboard/WelcomeBlock.vue'
import { ActionAPI } from '@/api/backend-client'
import { Action } from '@/api/model/action'
import { useCreateLeadForm } from '@/composables/useCreateLeadForm'
import moment from 'moment'

@Component({
    components: {
        ActionsBlock,
        ConversionBlock,
        LeaderboardBlock,
        RecentReferralsBlock,
        ReferralsBlock,
        LegacyReferralsBlock,
        TargetsBlock,
        WelcomeBlock,
    },
})
export default class Dashboard extends Vue {
    actionsStartDate: Date = null
    actionsEndDate: Date = null
    loadingActions: boolean = false
    actions: Action[] = []

    mounted() {
        this.actionsStartDate = moment().startOf('day').toDate()
        this.actionsEndDate = moment().add(6, 'days').endOf('day').toDate()
        this.loadActions()

        if ('create-lead' in this.$route.query) {
            const { open: openCreateLeadForm } = useCreateLeadForm()
            openCreateLeadForm()
        }
    }

    async loadActions(): Promise<void> {
        this.loadingActions = true
        this.actions = await ActionAPI.getAll({
            'view': 'branches',
            'actionDate[after]': this.actionsStartDate,
            'actionDate[before]': this.actionsEndDate,
        })
        this.loadingActions = false
    }
}
